import uuid from 'Lib/utils/uuid';

function TabWatcher() {
  let localStorageWorks = false;
  const tabIdKey = 'activeTabKey';
  const tabId = uuid();

  function register() {
    localStorage.setItem(tabIdKey, tabId);
    localStorageWorks = true;
  }

  function activeTabChange(): Promise<any> {
    if (!localStorageWorks) return Promise.reject(new Error('Local Storage unavailable.'));
    return new Promise((resolve) => {
      window.addEventListener('storage', (e) => {
        if (e.key !== tabIdKey) {
          return null;
        }

        if (e.newValue !== tabId) {
          return resolve(true);
        }

        return null;
      });
    });
  }

  return { register, activeTabChange };
}

export default TabWatcher();
